import React from "react";
import styled, { css } from "styled-components";

// components
import Text from "components/ui/Text";
// utils
import { specialFormatDate } from "utils/date";

const QnaCard = ({ title, userName, date, qnaDone, onClick }) => {
  return (
    <Wrapper onClick={onClick}>
      <LeftBlock>
        <Text
          fontSize="16px"
          fontWeight="500"
          lineHeight="24px"
          css={css`
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          `}
        >
          {title}
        </Text>
        <Text color="gray80" fontSize="14px" data-clarity-mask="True">
          {userName} &middot; {specialFormatDate(date)}
        </Text>
      </LeftBlock>
      <Status active={qnaDone === "Y"}>
        {qnaDone === "Y" ? "답변완료" : "답변대기"}
      </Status>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: 72px;
  padding: 12px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const LeftBlock = styled.div`
  width: calc(100% - 68px);
  display: flex;
  flex-direction: column;
`;

const Status = styled.div`
  width: 58px;
  height: 24px;
  padding: 4px 8px;
  border-radius: 16px;
  font-size: 12px;
  line-height: 16px;
  background-color: ${(props) =>
    props.active ? `rgba(0, 79, 236, 0.08)` : "#f2f2f4"};
  color: ${(props) => (props.active ? "#004FEC" : "#70747D")};
`;

export default QnaCard;
